import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/shared/hooks/useAuth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [showReload, setShowReload] = useState(false);

  // Check reactive user state since Firebase takes a moment to initialize
  const isAuthenticated = user !== null;

  useEffect(() => {
    const t = setTimeout(() => setShowReload(true), 3000);
    return () => clearTimeout(t);
  }, []);

  if (loading) {
    return (
      <div className="w-full flex flex-col items-center justify-center py-20 text-muted-foreground gap-3">
        <div>Loading...</div>
        {showReload && (
          <button
            onClick={() => window.location.reload()}
            className="underline text-foreground"
            aria-label="Reload session"
          >
            Still loading? Reload session
          </button>
        )}
      </div>
    );
  }

  // Use the reactive user state to redirect unauthenticated people to manual sign-in instead of auto-sandbox
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
